import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/containers/SmallScreenHeader/index.js";
const variants = import.meta.webpackContext("/containers/SmallScreenHeader", { recursive: true, regExp: /\.\/__variants__\/plp\-filtering\-experience\/v2\/index\.js/ });
export default pointCut({ joinPoint, variants });